// De fasen van een plan-run, zoals PlanRun.Phase ze kan bevatten. Spiegelt ApeJobPhases.cs:
// computing_matrix, solving en extracting komen van APE; applying is onze eigen fase voor het verwerken
// van het resultaat tot concept-ritten.
export const PlanRunPhase = {
  ComputingMatrix: 'computing_matrix',
  Solving: 'solving',
  Extracting: 'extracting',
  Applying: 'applying',
} as const;

/**
 * De stappen van de voortgangsweergave, in volgorde.
 *
 * De percentages zijn een indeling van de balk over de stappen, geen meting: APE geeft geen percentage en
 * geen resterende tijd, en zijn rekentijd is niet vooraf te bepalen (het zoekbudget is een ondergrens, en de
 * oplosfase kan een probe en twee escalaties bevatten die elk opnieuw dat budget mogen kosten). De balk
 * vertelt dus wáár de run is; de meelopende teller vertelt hoe lang hij al bezig is.
 *
 * "Voorbereiden" dekt alles vóór de eerste fase van APE: onze eigen wachttijd op de orkestratie én de
 * wachtrij van APE zelf. Die wachtrij krijgt geen eigen stap: hij is globaal en zonder organisatie, en per
 * organisatie staan wij maar één run toe, dus in de praktijk staat er nooit een run van onszelf voor.
 */
export interface PlanRunProgressStep {
  /** Fase waar deze stap bij hoort; null = de beginstap, die geen fase van APE heeft. */
  phase: string | null;
  percentage: number;
  labelKey: string;
}

export const PlanRunProgressSteps: PlanRunProgressStep[] = [
  { phase: null, percentage: 5, labelKey: 'components.transport.dayplanner.plan_run.progress.phase.preparing' },
  {
    phase: PlanRunPhase.ComputingMatrix,
    percentage: 25,
    labelKey: 'components.transport.dayplanner.plan_run.progress.phase.computing_matrix',
  },
  {
    phase: PlanRunPhase.Solving,
    percentage: 55,
    labelKey: 'components.transport.dayplanner.plan_run.progress.phase.solving',
  },
  {
    phase: PlanRunPhase.Extracting,
    percentage: 85,
    labelKey: 'components.transport.dayplanner.plan_run.progress.phase.extracting',
  },
  {
    phase: PlanRunPhase.Applying,
    percentage: 95,
    labelKey: 'components.transport.dayplanner.plan_run.progress.phase.applying',
  },
];

/** De stapindex van een fase, of 0 (de beginstap) voor een onbekende of ontbrekende fase. */
export const planRunStepIndexFor = (phase: string | null): number => {
  const index = PlanRunProgressSteps.findIndex((step) => step.phase === phase);

  return index === -1 ? 0 : index;
};
